import * as React from 'react'
const ApprovedIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M8.22 13.68h-.18a.51.51 0 01-.16-.09L5 10.68a.45.45 0 01.32-.77.44.44 0 01.31.13l2.59 2.57 6.14-6.17a.46.46 0 01.15-.09.38.38 0 01.34 0 .42.42 0 01.14.09.36.36 0 01.1.15.38.38 0 010 .34.44.44 0 01-.1.15l-6.48 6.48a.43.43 0 01-.29.12z" className="-primary-color" fill="#a5aab8"/>
      <path d="M10 18a8 8 0 115.66-2.34A8 8 0 0110 18zm0-15.11A7.1 7.1 0 1015 5a7.11 7.11 0 00-5-2.11z" className="-secondary-color" fill="#d7dae0"/>
    </svg>
    
  )
}

export default ApprovedIcon